class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = this.closest('.header-wrapper');
    this.updateMenuHeight = this.updateMenuHeight.bind(this);
  }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (this.mainDetailsToggle.open) {
      this.updateMenuHeight();
      window.addEventListener('resize', this.updateMenuHeight);
      window.addEventListener('scroll', this.updateMenuHeight, { passive: true });
      this.headerResizeObserver = this.headerResizeObserver || new ResizeObserver(this.updateMenuHeight);
      this.headerResizeObserver.observe(this.header);
    } else {
      this.stopUpdatingMenuHeight();
    }
  }

  updateMenuHeight() {
    if (!this.header || !this.mainDetailsToggle.open) return;

    const bottom = `${Math.max(0, Math.ceil(this.header.getBoundingClientRect().bottom))}px`;
    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== bottom) {
      document.documentElement.style.setProperty('--header-bottom-position-desktop', bottom);
    }
  }

  stopUpdatingMenuHeight() {
    window.removeEventListener('resize', this.updateMenuHeight);
    window.removeEventListener('scroll', this.updateMenuHeight);
    this.headerResizeObserver?.disconnect();
  }

  disconnectedCallback() {
    this.stopUpdatingMenuHeight();
  }
}

customElements.define('header-menu', HeaderMenu);
